import { useSetRecoilState } from 'recoil'

import { commentaryStore } from './useCommentaryStore'

const useCommentaryAction = () => {
    const setCommentaryStore = useSetRecoilState(commentaryStore)

    const setSelectedCommittedID = (selectedCommitteID: number) => {
        setCommentaryStore((prevState) => ({
            ...prevState,
            selectedCommitteeID: selectedCommitteID
        }))
    }

    return {
        setSelectedCommittedID,
    }
}

export default useCommentaryAction
